import React from 'react'
import Link from './link'

const Credits = ({credits, slug}) => {
  return credits && (
    <span>
      {`Credits → `}
      {credits.map(({name, twitter, website}, i) => (
        <span key={`${slug}-credit-${i}`}>
          {(credits.length > 1) && (i+1 === credits.length) ? (
            ` & `
          ) : (credits.length > 1) && (i > 0) && (
            `, `
          )}
          {website || twitter ? (
            <Link to={website ? website : `https://twitter.com/${twitter}`}>{name}</Link>
          ) : (
            <span >{name}</span>
          )}
        </span>
      ))}
    </span>
  )
}

export default Credits
